import * as yup from 'yup'

export const organizationSchema = yup.object().shape({
  logoId: yup.string().required().nullable().label('Logo'),
  name: yup.string().required().label('Organization'),
  addressLine1: yup.string().required().label('Address'),
  addressLine2: yup.string().label('Address'),
  city: yup.string().required().label('City'),
  state: yup.string().required().label('State'),
  postalCode: yup.string().required().label('Postal'),
  country: yup.string().required().label('Country'),
  phone: yup
    .string()
    .matches(/^\+(?:[0-9] ?){6,14}[0-9]$/, 'Phone number is not valid format try (+14095555555)')
    .label('Phone'),
  email: yup.string().email().required().label('Email'),
  socialFacebook: yup.string().url().label('Facebook'),
  socialTwitter: yup.string().url().label('Twitter'),
  socialInstagram: yup.string().url().label('Instagram'),
  socialLinkedin: yup.string().url().label('Linkedin'),
  socialWhatsapp: yup.string().url().label('Whatsapp'),
  baseUrl: yup.string().url().label('Base URL'),
  mediaUrl: yup.string().url().label('Media URL'),
  videoUrl: yup.string().url().label('Video URL'),
  apiUrl: yup.string().url().label('API URL'),
  callbackApiUrl: yup.string().url().label('Callback API URL')
})
